import { PartnerInquiry } from "@models";
import { contactService } from "@services";
import { makeAutoObservable, runInAction } from "mobx";

export default class ContactStore {
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  setLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };

  submitPartnerInquiry = async (inquiry: PartnerInquiry) => {
    this.setLoading(true);
    try {
      await contactService.submitPartnerInquiry(inquiry);
      return true;
    } catch {
      return false;
    } finally {
      this.setLoading(false);
    }
  };
}
